import { TFunction } from 'i18next';

import { PlaceResponse } from '@/api/lib/restaurant';

export function createPlaceSuggestions(t: TFunction, places: PlaceResponse[]) {
  if (!places || places.length === 0) {
    return null;
  }

  const alreadyInBase = t('proposeRestaurant.alreadyInBase');
  const placesSuggestions = places.map((place) => ({
    id: place.placeId,
    displayedText: `${place.name} ${place.exist ? `<b>(${alreadyInBase})</b> ✅` : ''}`,
    text: place.name
  }));

  return [
    {
      values: placesSuggestions
    }
  ];
}
